import React, { useState, useEffect } from 'react';
import { TagEntities } from '../../../api/services/next';
import TagsDropDown from '../../shared/TagsDropDown';
import { OperationsEnum } from '../../shared/constants';
import { onError, onSuccess } from '../../shared/messages';
import PropTypes from 'prop-types';

const TagEntitiesFactoryDropDown = ({
  IsSystem,
  HotelId,
  ChainId,
  EntityTypeId,
  EntityId,
  ...rest
}) => {
  const [tagEntities, setTagEntities] = useState([]);
  const [deletedEntityIds, setDeletedEntityIds] = useState([]);
  const apiPackage = { IsSystem, HotelId, ChainId, EntityTypeId, EntityId };

  useEffect(() => {
    TagEntities.GetFlatTagEntities({
      ...apiPackage,
    }).then(setTagEntities);
  }, []);

  const save = async () => {
    try {
      if (deletedEntityIds.length) {
        await TagEntities.DeleteTagEntities(deletedEntityIds);
        setDeletedEntityIds([]);
      }
      const newTags = tagEntities.filter(({ Id }) => Id === 0);

      if (newTags.length) {
        var savedTags = await TagEntities.CreateTagEntities(newTags);
        setTagEntities((prev) => [
          ...prev.filter(({ Id }) => Id !== 0),
          ...savedTags,
        ]);
      }
      onSuccess();
    } catch (error) {
      onError(error);
    }
  };

  const addTagHandler = (newTag) => {
    setTagEntities((prev) => [...prev, { ...newTag, TagId: newTag.Id, Id: 0 }]);
  };

  const changeTags = (currentTags) => {
    if (currentTags.length === tagEntities.length) return;

    const operation =
      tagEntities.length > currentTags.length
        ? OperationsEnum.REMOVE
        : OperationsEnum.ADD;

    const removedTag = tagEntities.find(
      ({ TagId }) => !currentTags.some(({ Id }) => Id === TagId)
    );
    const addedTag = currentTags.find(
      ({ Id }) => !tagEntities.some(({ TagId }) => TagId === Id)
    );
    if (operation === OperationsEnum.REMOVE && removedTag) {
      setDeletedEntityIds((prev) => [...prev, removedTag.Id]);
      setTagEntities((prev) =>
        prev.filter((tagEntity) => tagEntity !== removedTag)
      );
    } else if (operation === OperationsEnum.ADD && addedTag) {
      Reflect.deleteProperty(addedTag, 'Tag1');
      setTagEntities((prev) => [
        ...prev,
        { ...addedTag, TagId: addedTag.Id, Id: 0, EntityId },
      ]);
    }
    save();
  };

  return (
    <TagsDropDown
      onChangeItem={changeTags}
      value={tagEntities.map((t) => t.TagId)}
      IsSystem={IsSystem}
      HotelId={HotelId}
      ChainId={ChainId}
      EntityTypeId={EntityTypeId}
      onAddTag={addTagHandler}
      {...rest}
    />
  );
};

TagEntitiesFactoryDropDown.propTypes = {
  IsSystem: PropTypes.bool,
  HotelId: PropTypes.number,
  ChainId: PropTypes.number,
  EntityTypeId: PropTypes.number,
  EntityId: PropTypes.number,
};

export default TagEntitiesFactoryDropDown;
